import alert from '#utilities/js/ea/alert.js'
import all from "@mailobj-browser/front/js/selectors/all.js"

export default async element => {
  const items = all('ul li', element)

  queueMicrotask(async () => {
    for (const { textContent } of items) {
      await alert(textContent)
    }
  })
}
